import { ActionButton, Paginator, TableComponent } from "components";
import { useAppNavigate, useAppSearch } from "_graphql/cache/auth";
import { useUrlState, withPermissions } from "utils";

import ApproveOfferContainer from "./approve";
import clsx from "clsx";
import numeral from "numeral";
import { status_type } from "_graphql/__generated__/globalTypes-kek";
import { useKEKEndorsements } from "hooks/data/use-endorsement";
import { usePagination } from "hooks";

type Props = {};

const UnapprovedEndorsements = (props: Props) => {
  const { offset, limit, setPage, search, year } = usePagination();
  const searchParams = useAppSearch();
  const [modal, setModal] = useUrlState("modal");
  const navigate = useAppNavigate();
  const { endorsements, count, refetch, loading } = useKEKEndorsements({
    args: {
      approval_status: status_type.UNAPPROVED,
      offset,
      limit,
      search: search,
      //   from: fromDate,
      //   to: toDate,
      year: year,
    },
  });

  return (
    <>
      <TableComponent
        hasSearch
        title={"Unapproved endorsements"}
        emptyMessage="No unapproved endorsements found."
        columns={[
          {
            name: "Policy #",
            accessor: "0.policy_number",
            render: (value) => (
              <div className="flex flex-col items-start flex-wrap break-all break-words">
                <div className="flex flex-row items-center gap-x-1">
                  <span className="font-bold text-xs overflow-hidden text-ellipsis  ">
                    {value.offer_endorsement_detail?.policy_number || "N/A"}
                  </span>
                </div>
              </div>
            ),
          },
          {
            name: "Insurance Company",
            accessor: "insurer.insurer_company_name",
            render: (value) => (
              <div className="flex flex-col text-xs">
                <span className="font-medium">
                  {value.insurer?.insurer_company_name || "N/A"}
                </span>
                <span className="font-light">
                  {value.insurer?.insurer_company_email || "N/A"}
                </span>
              </div>
            ),
          },
          {
            name: "Insured",
            accessor: "offer_detail.insured_by",
            render: (value) => {
              const details = JSON.parse(
                value?.offer_endorsement_detail?.offer_detail || "[]"
              );
              return (
                <div className="flex flex-col text-xs ">
                  <span className="font-medium">
                    {value.offer_endorsement_detail?.insured_by || "N/A"}
                  </span>
                  <span className="font-light">
                    {[
                      "Motor Comprehensive Fleet",
                      "Motor Comprehensive",
                      "Motor Comprehensive (Automobile Fac Facility)",
                    ].includes(value?.classofbusiness?.business_name || "")
                      ? details?.find(
                          (el: { [x: string]: string }) =>
                            el?.["keydetail"] === "Vehicle Reg No" ||
                            el?.["keydetail"] === "Vehicle Reg No."
                        )?.value
                      : ""}
                  </span>
                </div>
              );
            },
          },
          {
            name: "Class Of Business",
            accessor: "classofbusiness.business_name",
            render: (value) => (
              <div className="flex flex-col text-xs">
                <span className="font-medium">
                  {value?.classofbusiness?.business_name || "N/A"}
                </span>
              </div>
            ),
          },
          {
            name: "Sum Insured",
            accessor: "sum_insured",
            render: (value) => (
              <div className="flex flex-col text-xs">
                <span className="font-medium">
                  {value?.offer_endorsement_detail?.currency}{" "}
                  {numeral(value.sum_insured).format("0,0 ") || "N/A"}
                </span>
              </div>
            ),
          },
          {
            name: "Rate",
            accessor: "rate",
          },
          {
            name: "Status",
            accessor: "offer_status",
            render: ({ endorsement_status }) => (
              <span
                className={clsx("text-xs", {
                  "text-blue-600": endorsement_status === "OPEN",
                  "text-yellow-600": endorsement_status === "PENDING",
                })}
              >
                {endorsement_status}
              </span>
            ),
          },
          {
            name: "Offer Date",
            accessor: "created_at",
            render: (value) => (
              <span>{new Date(value.created_at).toLocaleDateString()}</span>
            ),
          },
          {
            name: "Actions",
            accessor: "actions",
            render: ({ offer_endorsement_id }) => (
              <>
                {withPermissions([
                  "*:*",
                  "offers:*",
                  "offers:manage",
                  "offers:approve",
                ])(
                  <ActionButton
                    action="thumbs-up"
                    tooltip="Approve Offer"
                    onClick={() => {
                      navigate({
                        search: (old) => ({
                          ...old,
                          id: offer_endorsement_id ?? undefined,
                          modal: "accept",
                        }),
                      });
                    }}
                  />
                )}
              </>
            ),
          },
        ]}
        loading={loading}
        data={endorsements}
        refetch={refetch}
        pagination={() => (
          <Paginator
            offset={offset}
            limit={limit}
            totalItems={count}
            setOffset={setPage}
            currentSize={endorsements.length}
          />
        )}
      />
      {searchParams?.id && modal === "accept" && (
        <ApproveOfferContainer
          open={modal === "accept"}
          setOpen={(val: boolean) => setModal(val ? "accept" : undefined)}
        />
      )}
    </>
  );
};

export default UnapprovedEndorsements;
